import { TImageSettings } from '../interface/TImage'

export const MAX_FILE_SIZE = 30

export function getImageSettings(settings?: Partial<TImageSettings>): TImageSettings {
  return {
    width: settings && settings.width ? settings.width : '',
    caption: settings && settings.caption ? settings.caption : '',
    alt: settings && settings.alt ? settings.alt : '',
    url: settings && settings.url ? settings.url : '',
  }
}

export function isBase64(str: string) {
  if (str === '' || str.trim() === '') {
    return false
  }
  try {
    return window.btoa(window.atob(str)) == str
  } catch (err) {
    return false
  }
}

const signatures = {
  R0lGODdh: 'image/gif',
  R0lGODlh: 'image/gif',
  iVBORw0KGgo: 'image/png',
  '/9j/': 'image/jpg',
}

export function isImageMimeType(base64: string) {
  for (const s in signatures) {
    if (base64.indexOf(s) === 0) {
      return true
    }
  }

  return false
}

export function isBase64Image(str: string) {
  const base64 = str.split('base64,')
  return base64.length === 2 && isBase64(base64[1]) && isImageMimeType(base64[1])
}
